// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingDisplay {
    display: block;
    max-width: 20em;
    max-height: 70%;
    margin-left: auto;
    margin-right: auto;
}

.imageGridDisplay {
    display: block;
    max-height: 10em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}

.ImageSelectorMetaDataContent {
    text-align: center;
    overflow: hidden;
    border: 2px solid var(--templatesColorBackgroundInContainer);
    border-radius: 5px;
    display: inline-block;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 15em;
    padding-bottom: 1em;
}

.ImageSelectorMetaDataContent p,
a {
    color: gray;
}

.ImageSelectorBackButtonContainer {
    display: flex;
    justify-content: right;

    padding: 4px;
}

.ImageSelectorTitle {
    text-align: center;
}

.ImageSelectorBackButton {
    color: white;
    border: none;
    outline: none;
    background-color: var(--templatesColorBackgroundContainer);
    cursor: pointer;
}

.ImageSelectorBackButton:hover {
    background-color: var(--templatesColorBackgroundInContainer);
}

.ImageSelectorOverLayeContainer {
    position: fixed;
    top: 50%;
    /* position the top  edge of the element at the middle of the parent */
    left: 50%;
    /* position the left edge of the element at the middle of the parent */
    z-index: 35;
    transform: translate(-50%, -50%);
}

.ImageSelectorAnimationContainer {
    animation: popup 0.5s normal forwards ease-in-out;
}

.ImageSelectorSearchLayerContainerBlur {
    filter: blur(3px) grayscale(5);
    pointer-events: none;
}

.ImageLoaderImageContainer {
    padding: 0.5em;
    border-radius: 5px;
    animation: fadeInGlobal 1s;
    scroll-behavior: smooth;
}

.ImageLoaderImageContainerSelected {
    opacity: 0.2;
    padding: 0.5em;
    border-radius: 5px;
    filter: grayscale(100%);
    animation: fadeInGlobal 1s;
}

.ImageLoaderImageContainerSelected:hover {
    opacity: 1;
    cursor: pointer;
    filter: grayscale(0%);
    transform: scale(1.1);
}

.ImageLoaderImageContainer:hover {
    cursor: pointer;
    transform: scale(1.1);
}

.ImageLoaderImageContainerDisplayNone {
    display: none;
}

.ImageLoaderImageContainerContainer {
    padding-top: 1em;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.3em;
}

.ImageSelectorStatusMessage {
    text-align: center;
}

.ImageLoaderImageDisplayBrowse {
    display: block;
    max-height: 10em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
}
.imageSelectorBackButtonContainerWrapper{
    min-height: 29em;
}
.ImageSelectorLineBreak {
    height: 3px;
    background-color: var(--templatesColorBackgroundInContainer);
    border: none;
}

.reportFlag {
    font-size: 10px;
    cursor: pointer;
    opacity: 0.5;
    position: relative;
    color: lightcoral;
    margin-top: -20px;
}

.reportFlagContainer {
    position: absolute;
}

.reportText {
    text-align: center;
}

.reportSpanText {
    color: white;
}

.reporterSpanAndSelectorContainer {
    text-align: center;
}

@media only screen and (max-width: 768px) {
    .ImageSelectorOverLayeContainer {
        left: 50%;
        right: 50%;
        top: 20%;
        transform: none;
        position: fixed;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .globalImageContainer {
        background-color: var(--templatesColorBackgroundInContainer);
        width: 160px;
        border-radius: 20px;
    }

    .ImageLoaderImageDisplayBrowse {
        max-height: 90px;
    }

    .imageGridDisplay {
        display: block;
        max-height: 8em;
        margin-left: auto;
        margin-right: auto;
    }

    .cardContainer {
        padding: 2px;
    }

    .TemplatesContainer {
        padding-left: 1px;
        padding-right: 1px;
    }
}

@keyframes popup {
    0% {
        transform: scale(0, 1);
    }

    100% {
        transform: scale(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Templates/Browse/Browse.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4D;IAC5D,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,0DAA0D;IAC1D,eAAe;AACnB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,sEAAsE;IACtE,SAAS;IACT,sEAAsE;IACtE,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,+CAA+C;AACnD;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,4DAA4D;IAC5D,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,SAAS;QACT,UAAU;QACV,QAAQ;QACR,eAAe;QACf,eAAe;QACf,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,4DAA4D;QAC5D,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".loadingDisplay {\n    display: block;\n    max-width: 20em;\n    max-height: 70%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.imageGridDisplay {\n    display: block;\n    max-height: 10em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n\n.ImageSelectorMetaDataContent {\n    text-align: center;\n    overflow: hidden;\n    border: 2px solid var(--templatesColorBackgroundInContainer);\n    border-radius: 5px;\n    display: inline-block;\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 15em;\n    padding-bottom: 1em;\n}\n\n.ImageSelectorMetaDataContent p,\na {\n    color: gray;\n}\n\n.ImageSelectorBackButtonContainer {\n    display: flex;\n    justify-content: right;\n\n    padding: 4px;\n}\n\n.ImageSelectorTitle {\n    text-align: center;\n}\n\n.ImageSelectorBackButton {\n    color: white;\n    border: none;\n    outline: none;\n    background-color: var(--templatesColorBackgroundContainer);\n    cursor: pointer;\n}\n\n.ImageSelectorBackButton:hover {\n    background-color: var(--templatesColorBackgroundInContainer);\n}\n\n.ImageSelectorOverLayeContainer {\n    position: fixed;\n    top: 50%;\n    /* position the top  edge of the element at the middle of the parent */\n    left: 50%;\n    /* position the left edge of the element at the middle of the parent */\n    z-index: 35;\n    transform: translate(-50%, -50%);\n}\n\n.ImageSelectorAnimationContainer {\n    animation: popup 0.5s normal forwards ease-in-out;\n}\n\n.ImageSelectorSearchLayerContainerBlur {\n    filter: blur(3px) grayscale(5);\n    pointer-events: none;\n}\n\n.ImageLoaderImageContainer {\n    padding: 0.5em;\n    border-radius: 5px;\n    animation: fadeInGlobal 1s;\n    scroll-behavior: smooth;\n}\n\n.ImageLoaderImageContainerSelected {\n    opacity: 0.2;\n    padding: 0.5em;\n    border-radius: 5px;\n    filter: grayscale(100%);\n    animation: fadeInGlobal 1s;\n}\n\n.ImageLoaderImageContainerSelected:hover {\n    opacity: 1;\n    cursor: pointer;\n    filter: grayscale(0%);\n    transform: scale(1.1);\n}\n\n.ImageLoaderImageContainer:hover {\n    cursor: pointer;\n    transform: scale(1.1);\n}\n\n.ImageLoaderImageContainerDisplayNone {\n    display: none;\n}\n\n.ImageLoaderImageContainerContainer {\n    padding-top: 1em;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 0.3em;\n}\n\n.ImageSelectorStatusMessage {\n    text-align: center;\n}\n\n.ImageLoaderImageDisplayBrowse {\n    display: block;\n    max-height: 10em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n}\n.imageSelectorBackButtonContainerWrapper{\n    min-height: 29em;\n}\n.ImageSelectorLineBreak {\n    height: 3px;\n    background-color: var(--templatesColorBackgroundInContainer);\n    border: none;\n}\n\n.reportFlag {\n    font-size: 10px;\n    cursor: pointer;\n    opacity: 0.5;\n    position: relative;\n    color: lightcoral;\n    margin-top: -20px;\n}\n\n.reportFlagContainer {\n    position: absolute;\n}\n\n.reportText {\n    text-align: center;\n}\n\n.reportSpanText {\n    color: white;\n}\n\n.reporterSpanAndSelectorContainer {\n    text-align: center;\n}\n\n@media only screen and (max-width: 768px) {\n    .ImageSelectorOverLayeContainer {\n        left: 50%;\n        right: 50%;\n        top: 20%;\n        transform: none;\n        position: fixed;\n        margin: 0 auto;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .globalImageContainer {\n        background-color: var(--templatesColorBackgroundInContainer);\n        width: 160px;\n        border-radius: 20px;\n    }\n\n    .ImageLoaderImageDisplayBrowse {\n        max-height: 90px;\n    }\n\n    .imageGridDisplay {\n        display: block;\n        max-height: 8em;\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .cardContainer {\n        padding: 2px;\n    }\n\n    .TemplatesContainer {\n        padding-left: 1px;\n        padding-right: 1px;\n    }\n}\n\n@keyframes popup {\n    0% {\n        transform: scale(0, 1);\n    }\n\n    100% {\n        transform: scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
